// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.sidebar {
  width: 250px;
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  position: relative;
}

.sidebar.closed {
  width: 60px;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.logo {
  font-size: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  max-width: 100%;
  max-height: 50px;
  object-fit: contain;
}

.logo-text {
  color: #1976d2;
  font-weight: bold;
  font-size: 18px;
}

.sidebar-nav {
  flex: 1 1;
  padding: 20px 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.nav-item:hover {
  background-color: #f0f0f0;
}

.nav-item.active {
  background-color: #e3f2fd;
  color: #1976d2;
  font-weight: 600;
}

.nav-icon {
  font-size: 20px;
  margin-right: 12px;
  width: 24px;
  text-align: center;
}

.sidebar.closed .nav-text {
  display: none;
}

.sidebar-footer {
  border-top: 1px solid #e0e0e0;
  padding: 10px 0;
}

.sidebar-toggle {
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
}

.logo-small {
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image-small {
  max-width: 150px;
  max-height: 40px;
  object-fit: contain;
}

.logo-text-small {
  color: #1976d2;
  font-weight: bold;
  font-size: 16px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notification-badge-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff3e0;
  border: 1px solid #ff9800;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.notification-badge-container:hover {
  background-color: #ffe0b2;
}

.notification-icon {
  font-size: 18px;
  animation: ring 2s ease-in-out infinite;
}

@keyframes ring {
  0%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(-10deg); }
  20%, 40% { transform: rotate(10deg); }
}

.notification-count {
  background-color: #ff9800;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 12px;
  min-width: 20px;
  text-align: center;
}

.notification-text {
  color: #e65100;
  font-size: 14px;
  font-weight: 500;
}

.user-avatar-container {
  position: relative;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.user-avatar:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.user-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  min-width: 200px;
  z-index: 1000;
  overflow: hidden;
}

.user-menu-header {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8f9fa;
}

.user-menu-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

.user-menu-info {
  flex: 1 1;
  min-width: 0;
}

.user-menu-name {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-email {
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 8px 0;
}

.user-menu-item {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  color: #333;
  transition: background-color 0.2s;
}

.user-menu-item:hover {
  background-color: #f5f5f5;
}

.user-menu-icon {
  font-size: 18px;
}

.content {
  flex: 1 1;
  padding: 30px;
  overflow-y: auto;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}

.footer-left p {
  margin: 5px 0;
  color: #666;
  font-size: 14px;
}

/* Change Password Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.change-password-modal {
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.change-password-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.change-password-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 0;
  line-height: 1;
}

.modal-close-btn:hover {
  color: #333;
}

.change-password-form {
  padding: 24px;
}

.change-password-field {
  margin-bottom: 18px;
}

.change-password-field label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.change-password-field input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.change-password-field input:focus {
  outline: none;
  border-color: #667eea;
}

.change-password-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 6px;
}

.change-password-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.change-password-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.change-password-error {
  background-color: #fee;
  color: #c33;
  padding: 10px 12px;
  border-radius: 5px;
  margin-bottom: 16px;
  border: 1px solid #fcc;
  font-size: 14px;
}

.change-password-success {
  background-color: #e6f9ee;
  color: #1a7a3a;
  padding: 10px 12px;
  border-radius: 5px;
  margin-bottom: 16px;
  border: 1px solid #a3e4bc;
  font-size: 14px;
}


`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,WAAW,yBAAyB,EAAE;EACtC,WAAW,wBAAwB,EAAE;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".layout {\n  display: flex;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.sidebar {\n  width: 250px;\n  background-color: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  position: relative;\n}\n\n.sidebar.closed {\n  width: 60px;\n}\n\n.sidebar-header {\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.logo {\n  font-size: 32px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-image {\n  max-width: 100%;\n  max-height: 50px;\n  object-fit: contain;\n}\n\n.logo-text {\n  color: #1976d2;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 20px 0;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  color: #333;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.nav-item:hover {\n  background-color: #f0f0f0;\n}\n\n.nav-item.active {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  font-weight: 600;\n}\n\n.nav-icon {\n  font-size: 20px;\n  margin-right: 12px;\n  width: 24px;\n  text-align: center;\n}\n\n.sidebar.closed .nav-text {\n  display: none;\n}\n\n.sidebar-footer {\n  border-top: 1px solid #e0e0e0;\n  padding: 10px 0;\n}\n\n.sidebar-toggle {\n  position: absolute;\n  right: -15px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 1px solid #e0e0e0;\n  background: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 30px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.logo-small {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-image-small {\n  max-width: 150px;\n  max-height: 40px;\n  object-fit: contain;\n}\n\n.logo-text-small {\n  color: #1976d2;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.notification-badge-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #fff3e0;\n  border: 1px solid #ff9800;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.notification-badge-container:hover {\n  background-color: #ffe0b2;\n}\n\n.notification-icon {\n  font-size: 18px;\n  animation: ring 2s ease-in-out infinite;\n}\n\n@keyframes ring {\n  0%, 100% { transform: rotate(0deg); }\n  10%, 30% { transform: rotate(-10deg); }\n  20%, 40% { transform: rotate(10deg); }\n}\n\n.notification-count {\n  background-color: #ff9800;\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 2px 8px;\n  border-radius: 12px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.notification-text {\n  color: #e65100;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.user-avatar-container {\n  position: relative;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.user-avatar:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.user-menu {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  min-width: 200px;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.user-menu-header {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #f8f9fa;\n}\n\n.user-menu-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.user-menu-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-menu-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu-email {\n  font-size: 12px;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 8px 0;\n}\n\n.user-menu-item {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  color: #333;\n  transition: background-color 0.2s;\n}\n\n.user-menu-item:hover {\n  background-color: #f5f5f5;\n}\n\n.user-menu-icon {\n  font-size: 18px;\n}\n\n.content {\n  flex: 1;\n  padding: 30px;\n  overflow-y: auto;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #e0e0e0;\n}\n\n.footer-left p {\n  margin: 5px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Change Password Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.change-password-modal {\n  background: white;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.change-password-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eee;\n}\n\n.change-password-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n  line-height: 1;\n}\n\n.modal-close-btn:hover {\n  color: #333;\n}\n\n.change-password-form {\n  padding: 24px;\n}\n\n.change-password-field {\n  margin-bottom: 18px;\n}\n\n.change-password-field label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.change-password-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.change-password-field input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.change-password-btn {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-top: 6px;\n}\n\n.change-password-btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.change-password-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.change-password-error {\n  background-color: #fee;\n  color: #c33;\n  padding: 10px 12px;\n  border-radius: 5px;\n  margin-bottom: 16px;\n  border: 1px solid #fcc;\n  font-size: 14px;\n}\n\n.change-password-success {\n  background-color: #e6f9ee;\n  color: #1a7a3a;\n  padding: 10px 12px;\n  border-radius: 5px;\n  margin-bottom: 16px;\n  border: 1px solid #a3e4bc;\n  font-size: 14px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
